(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  (function () {
    var post = document.getElementById('ogPost');
    if (!post) return;
    var content = post.querySelector('.og-post__content');
    var toc = post.querySelector('.og-post__toc');
    var bar = document.querySelector('.og-progress span');

    if (content && toc) {
      var heads = content.querySelectorAll('h2');
      if (heads.length > 2) {
        var ol = toc.querySelector('ol');
        heads.forEach(function (h, i) {
          if (!h.id) h.id = 'sez-' + i;
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = '#' + h.id;
          a.textContent = h.textContent;
          li.appendChild(a);
          ol.appendChild(li);
        });
        toc.hidden = false;

        if ('IntersectionObserver' in window) {
          var links = ol.querySelectorAll('a');
          var obs = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (!e.isIntersecting) return;
              links.forEach(function (l) {
                l.classList.toggle('is-active', l.getAttribute('href') === '#' + e.target.id);
              });
            });
          }, { rootMargin: '-10% 0px -75% 0px' });
          heads.forEach(function (h) { obs.observe(h); });
        }
      }
    }

    if (bar && content) {
      var tick = function () {
        var r = content.getBoundingClientRect();
        var tot = r.height - window.innerHeight;
        var p = tot > 0 ? Math.min(1, Math.max(0, -r.top / tot)) : 0;
        bar.style.transform = 'scaleX(' + p + ')';
      };
      window.addEventListener('scroll', tick, { passive: true });
      window.addEventListener('resize', tick, { passive: true });
      tick();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
